import React, {useEffect,useState}  from 'react';
import { SessionProvider } from '../../core/providers/SessionProvider.jsx';
import { ThemeProvider } from '../../core/providers/ThemeProvider.jsx';
import { LanguageProvider } from '../../core/providers/LanguageProvider.jsx';
// import { PaymentStatusProvider } from '../../core/providers/PaymentStatusProvider.jsx';
import { PermissionProvider } from '../../core/providers/PermissionProvider.jsx';
import { AppRouter } from '../router/AppRouter.jsx';
import { toast, ToastContainer } from 'react-toastify';

import { getToken , onMessage} from "firebase/messaging";
import { messaging } from "AssetsM/firebase.js";

import ErrorBoundary from 'AssetsM/ErrorBoundary.js';

// /*CSS*/
import 'bootstrap-icons/font/bootstrap-icons.css';
import "gridjs/dist/theme/mermaid.css";
import 'react-toastify/dist/ReactToastify.css';

/**
 * Bootstrap.jsx
 *
 * THE single place responsible for turning a raw login response into
 * a fully running application. Nothing else in the app is allowed to
 * read `session.system.*` directly and reinterpret it — Bootstrap
 * reads it once and hands each piece to the provider that owns it.
 *
 * Pipeline (mirrors the required architecture 1:1):
 *
 *   1. Loading session         -> `session` prop (already loaded by App.jsx)
 *   2. Reading configuration   -> `session.system`
 *   3. Loading theme           -> <ThemeProvider>
 *   4. Loading layout          -> handled inside <AppRouter>'s <MainLayout>
 *   5. Loading enabled modules -> <PermissionProvider>
 *   6. Loading routes          -> <AppRouter>
 *   7. Loading sidebar         -> <Sidebar> (reads PermissionProvider, rendered by MainLayout)
 *   8. Rendering application   -> final JSX returned below
 *
 * No `if (systemId === 'doctor')` branch exists anywhere in this file
 * or anywhere downstream — every step only ever reads generic fields
 * off the `system` object.
 */
export function Bootstrap({ session, onLogout }) {
  // Step 1 & 2: session + configuration are already available as props.
  const { system } = session;
  const [isDarkMode, setIsDarkMode] = useState(true);
  
  const TostOnlineGonfFunction = (icon, color, text) =>  {
    return {
        position: "bottom-left",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        
        icon: <span className={`bi bi-${icon} bi-md text-${color}`}></span>,
        style: {
            backgroundColor: '#424242', // Custom background color
            color: '#fff'            // Custom text color
        }
    }
}

const TostNotiftGonf = {
        position: "bottom-right",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        onClick : () => window.location.href = "/S/rq",
        icon: <span className="bi bi-bell-fill bi-sm text-warning"></span>,
        style: {
            backgroundColor: '#333', // Custom background color
            color: '#fff'            // Custom text color
        }
    } 

  useEffect(() => {
    const loadStyles = async () => {
      if (system.theme.dark) {
        await import('AssetsM/dark_theme.css');
      } else {
        // Optionally handle the light mode styles if needed
      }
    };

    loadStyles();
  }, [isDarkMode]);


  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload);
    
    const audio = new Audio('https://cdn.abyedh.com/Sounds/notif.mp3');
    audio.play();

    toast(<>
          <div className='p-1'>
              <h3 className='text-white mb-0'>{payload.notification.title}</h3> 
              <h5 className='text-secondary mt-1'>{payload.notification.body}</h5>
          </div>
        </>,TostNotiftGonf)
    // Customize notification here
    // new Notification(payload.notification.title, {
    //   body: payload.notification.body,
    //   data: { 
    //     url: payload.notification.url,
    //     photo: payload.notification.photo,
    //   }
    // });

  });
  
  useEffect(() => {
    
    const handleOnline = () => {
      toast.dismiss();
      toast(<>
        <div className='p-1'>
            <h6 className='text-white mb-0'>Votre connexion Internet a été rétablie.</h6> 
        </div>
      </>, TostOnlineGonfFunction('wifi','success'))
    };
    
    const handleOffline = () => {
      toast.dismiss();
      toast(<>
        <div className='p-1'>
            <h6 className='text-white mb-0'>Vous êtes actuellement hors ligne.</h6> 
        </div>
      </>, TostOnlineGonfFunction('wifi-off','danger'))
    };

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup event listeners on unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <ErrorBoundary>
    { /* // Step 6/8 context: session data available app-wide (user info, logout). */}
      <SessionProvider session={session} onLogout={onLogout}>
        {/* Step 3: theme loaded from system.theme + system.title */}
        {/* <PaymentStatusProvider> */}
          <ThemeProvider theme={system.theme} title={system.title}>
            {/* Step: language provider prepared (not translated)  I MAY REMOVE THIS §§§§§§§§§§§§§*/}
            <LanguageProvider initialLanguage={system.language}>
              {/* Step 5: enabled modules become the permission surface */}
              <PermissionProvider enabledModules={system.modules}>
                {/* Step 4, 6, 7: layout + routes + sidebar, all generated */}
                <AppRouter systemId={system.id} enabledModules={system.modules} />
              </PermissionProvider>
            </LanguageProvider>
          </ThemeProvider>
        {/* </PaymentStatusProvider> */}
      </SessionProvider>
    </ErrorBoundary>
  );
}
